/* eslint-disable import/prefer-default-export */
import * as actionTypes from 'actions/actionTypes';

export const initAnalyticsData = (storeState) => ({
  type: actionTypes.INIT_ANALYTICS_DATA,
  data: storeState,
});

export const track = (eventName, meta = {}, trackingModel = 'legacy') => ({
  type: actionTypes.TRACK_ANALYTICS_DATA,
  meta: {
    event: eventName,
    trackingModel,
    ...meta,
  },
});

export const deleteShouldReportAuthEvent = () => ({
  type: actionTypes.DELETE_SHOULD_REPORT_AUTH_EVENT,
});
